import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAutoRotate } from 'store/actions';
import './style.scss';

function PauseButton() {
  const { autoRotate } = useSelector((state) => ({
    autoRotate: state.autoRotate,
  }));

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setAutoRotate(!autoRotate));
  };

  return (
    <div
      type="button"
      className="pause-button"
      onClick={handleClick}
      aria-label={autoRotate ? 'Pause rotation' : 'Play rotation'}
    >
      {!autoRotate ? (
        // Icon Play
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.82567 2.02963C3.7681 1.45453 2.50012 2.21305 2.50012 3.35533L2.50012 12.6448C2.50012 13.7871 3.7681 14.5456 4.82567 13.9705L13.367 9.32576C14.4334 8.74584 14.4334 7.25429 13.367 6.67437L4.82567 2.02963ZM1.50012 3.35533C1.50012 1.41865 3.61128 0.230959 5.3034 1.15113L13.8447 5.79586C15.6075 6.75446 15.6075 9.24566 13.8447 10.2043L5.3034 14.849C3.61128 15.7692 1.50012 14.5815 1.50012 12.6448L1.50012 3.35533Z"
            fill="white"
          />
        </svg>
      ) : (
        // Icon Pause
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_325_575)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.96531 0.833253H4.03465C4.63363 0.833233 5.13311 0.833217 5.52963 0.886528C5.94816 0.942797 6.32603 1.06658 6.62968 1.37022C6.93332 1.67387 7.0571 2.05174 7.11337 2.47027C7.16668 2.86679 7.16667 3.36627 7.16665 3.96526V12.0346C7.16667 12.6336 7.16668 13.1331 7.11337 13.5296C7.0571 13.9481 6.93332 14.326 6.62968 14.6296C6.32603 14.9333 5.94816 15.057 5.52963 15.1133C5.13311 15.1666 4.63363 15.1666 4.03464 15.1666H3.96532C3.36633 15.1666 2.86685 15.1666 2.47033 15.1133C2.0518 15.057 1.67393 14.9333 1.37029 14.6296C1.06664 14.326 0.942858 13.9481 0.886589 13.5296C0.833278 13.1331 0.833294 12.6336 0.833314 12.0346V3.96525C0.833294 3.36627 0.833278 2.86679 0.886589 2.47027C0.942858 2.05174 1.06664 1.67387 1.37029 1.37022C1.67393 1.06658 2.0518 0.942797 2.47033 0.886528C2.86685 0.833217 3.36633 0.833233 3.96531 0.833253ZM2.60358 1.87761C2.29593 1.91897 2.16427 1.99045 2.07739 2.07733C1.99051 2.16421 1.91903 2.29587 1.87767 2.60351C1.83438 2.92554 1.83331 3.35725 1.83331 3.99992V11.9999C1.83331 12.6426 1.83438 13.0743 1.87767 13.3963C1.91903 13.704 1.99051 13.8356 2.07739 13.9225C2.16427 14.0094 2.29594 14.0809 2.60358 14.1222C2.9256 14.1655 3.35731 14.1666 3.99998 14.1666C4.64266 14.1666 5.07436 14.1655 5.39639 14.1222C5.70403 14.0809 5.83569 14.0094 5.92257 13.9225C6.00945 13.8356 6.08093 13.704 6.12229 13.3963C6.16559 13.0743 6.16665 12.6426 6.16665 11.9999V3.99992C6.16665 3.35725 6.16559 2.92554 6.12229 2.60351C6.08093 2.29587 6.00945 2.16421 5.92257 2.07733C5.83569 1.99045 5.70403 1.91897 5.39639 1.87761C5.07436 1.83432 4.64266 1.83325 3.99998 1.83325C3.35731 1.83325 2.9256 1.83432 2.60358 1.87761ZM11.9653 0.833253H12.0346C12.6336 0.833233 13.1331 0.833217 13.5296 0.886528C13.9482 0.942797 14.326 1.06658 14.6297 1.37022C14.9333 1.67387 15.0571 2.05174 15.1134 2.47027C15.1667 2.86679 15.1667 3.36627 15.1666 3.96526V12.0346C15.1667 12.6336 15.1667 13.1331 15.1134 13.5296C15.0571 13.9481 14.9333 14.326 14.6297 14.6296C14.326 14.9333 13.9482 15.057 13.5296 15.1133C13.1331 15.1666 12.6336 15.1666 12.0346 15.1666H11.9653C11.3663 15.1666 10.8668 15.1666 10.4703 15.1133C10.0518 15.057 9.67393 14.9333 9.37029 14.6296C9.06664 14.326 8.94286 13.9481 8.88659 13.5296C8.83328 13.1331 8.83329 12.6336 8.83331 12.0346V3.96526C8.83329 3.36627 8.83328 2.86679 8.88659 2.47027C8.94286 2.05174 9.06664 1.67387 9.37029 1.37022C9.67393 1.06658 10.0518 0.942797 10.4703 0.886528C10.8668 0.833217 11.3663 0.833233 11.9653 0.833253ZM10.6036 1.87761C10.2959 1.91897 10.1643 1.99045 10.0774 2.07733C9.99051 2.16421 9.91903 2.29587 9.87767 2.60351C9.83438 2.92554 9.83331 3.35725 9.83331 3.99992V11.9999C9.83331 12.6426 9.83438 13.0743 9.87767 13.3963C9.91903 13.704 9.99051 13.8356 10.0774 13.9225C10.1643 14.0094 10.2959 14.0809 10.6036 14.1222C10.9256 14.1655 11.3573 14.1666 12 14.1666C12.6427 14.1666 13.0744 14.1655 13.3964 14.1222C13.704 14.0809 13.8357 14.0094 13.9226 13.9225C14.0094 13.8356 14.0809 13.704 14.1223 13.3963C14.1656 13.0743 14.1666 12.6426 14.1666 11.9999V3.99992C14.1666 3.35725 14.1656 2.92554 14.1223 2.60351C14.0809 2.29587 14.0094 2.16421 13.9226 2.07733C13.8357 1.99045 13.704 1.91897 13.3964 1.87761C13.0744 1.83432 12.6427 1.83325 12 1.83325C11.3573 1.83325 10.9256 1.83432 10.6036 1.87761Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_325_575">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
}

export default PauseButton;
